import React, { useState } from "react";
import './Lightbox.css';

export default function Lightbox({ images, renderChild }) {
    const [currentIndex, setCurrentIndex] = useState();
    const [imageToShow, setImageToShow] = useState("");
    const [lightboxDisplay, setLightBoxDisplay] = useState(false);

    //function to show a specific image in the lightbox, amd make lightbox visible
    const showImage = (image) => {
        setCurrentIndex(images.indexOf(image));
        setImageToShow(image.file);
        setLightBoxDisplay(true);
    };

    //hide lightbox
    const hideLightBox = () => {
        setLightBoxDisplay(false);
    };

    //show next image in lightbox
    const showNext = (e) => {
        e.stopPropagation();

        const nextImageIndex = currentIndex >= images.length - 1
            ? 0
            : currentIndex + 1;

        setCurrentIndex(nextImageIndex);
        setImageToShow(images[nextImageIndex].file);
    };

    //show previous image in lightbox
    const showPrev = (e) => {
        e.stopPropagation();

        const prevImageIndex = currentIndex <= 0
            ? images.length - 1
            : currentIndex - 1;

        setCurrentIndex(prevImageIndex);
        setImageToShow(images[prevImageIndex].file);
    };

    return (
        <>
            {
                images.map((image) => renderChild(image, () => showImage(image)))
            }

            {
                lightboxDisplay ?
                    <div id="lightbox" onClick={ hideLightBox }>
                        <button onClick={ showPrev }>⭠</button>
                        <img id="lightbox-img" src={ imageToShow }></img>
                        <button onClick={ showNext }>⭢</button>
                    </div>
                    : ""
            }
        </>
    );
}